import { lazy } from 'react';

export { MyEntriesPath } from './url';
export const MyEntriesRoutesLazy = lazy(() => import('./Routes.jsx'));
